import { GAME_STATUSES } from '@blind-kings/game-core';
import BkPanel from '../../Components/ui/BkPanel';
import usePageMeta from '../../hooks/use-page-meta';
import Game from './Game';
import GameInfo from './GameInfo';
import GameNotFound from './GameNotFound';
import useGameRouter from './hooks/use-game-router';

export default function GameRouter() {
  usePageMeta({
    title: 'Match',
    description: 'Blind Kings live match.',
    path: '/play',
    noindex: true,
  });

  const { gameId, game, finishedInitialQuery, applyGameUpdate } = useGameRouter();

  if (!finishedInitialQuery) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center px-6 py-12">
        <BkPanel className="w-full max-w-xl text-center">
          <h1 className="text-2xl font-bold uppercase tracking-wider text-bk-gold animate-bk-pulse-soft sm:text-4xl md:text-5xl">
            Loading Game
          </h1>
        </BkPanel>
      </div>
    );
  }

  if (!game?.gameId) {
    const reason =
      game?.error === 'auth' || game?.error === 'forbidden'
        ? game.error
        : 'not_found';
    return (
      <GameNotFound
        gameId={gameId}
        reason={reason}
        message={typeof game?.message === 'string' ? game.message : undefined}
      />
    );
  }

  if (game.status === GAME_STATUSES.QUEUED) {
    return <GameInfo game={game} applyGameUpdate={applyGameUpdate} />;
  }

  if (game.status === GAME_STATUSES.STARTED || game.status === GAME_STATUSES.FINISHED) {
    return <Game key={String(game.gameId)} game={game} applyGameUpdate={applyGameUpdate} />;
  }

  return (
    <div className="flex flex-col items-center px-6 py-12">
      <BkPanel className="w-full max-w-5xl text-center">
        <h1 className="text-2xl font-bold uppercase tracking-wider text-bk-gold sm:text-4xl">
          Review Game Coming Soon
        </h1>
      </BkPanel>
    </div>
  );
}
